import {Helmet} from "react-helmet";
import React, { Component } from "react";
import { Button, Container, Tabs, Tab, Table } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import ShowEntries from "../commoncomponents/ShowEntries";

import Search from "../commoncomponents/Search";
import Paginations from "../commoncomponents/pagination";
import { encodeQueryData } from "../../api/apiClient";
import ShowingResults from "../commoncomponents/showingResults";
import Layout from "../../Layout/layout";
import {setLoadingPage,setErrorMessage} from '../../reducers/actions';
import { connect } from 'react-redux';
import {utcToLocal} from '../../utils/dateConvert'

class UserDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetails: [],
      groupDetails: [],
      assetDetails: [],
      assetPageCount: 0,
      groupPageCount: 0,
      //states for showing entries and total entries in page on groups
      totalEntryG: 0,
      entryStartG: "1",
      entryEndG: "10",
      totalFilterG: false,
      totalEntryFilterG: "",
      filterMessageG: false,
      //states for showing entries and total entries in page on Assets
      totalEntryA: 0,
      entryStartA: "1",
      entryEndA: "10",
      totalFilterA: false,
      totalEntryFilterA: "",
      filterMessageA: false,

  //Group table sort
         sortStringGroup: 'name',
         sortDirectionGroup: 'asc',
         //Asser table sort
         sortString: 'name',
         sortDirection: 'asc',
       }
       this.sortStringName = 'name';
       this.sortDirection = 'asc';
       this.sortStringNameGroup = 'name';
       this.sortDirectionGroup = 'asc';
    this.groupsPageSize = "10";
    this.groupsSearchText = "";
    this.groupsPageKey = "1";
    this.assetsPageSize = "10";
    this.assetsSearchText = "";
    this.assetsPageKey = "1";
  }
  async componentDidMount() {
    let userId = this.props.match.params.id;
    let query = encodeQueryData(this.setGroupQueryObject());
    try {
      const userDetail = await axios.get(
        `${apiHost}/api/Auth/UpdateUsers/${userId}?${query}`,

        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );
      this.setState({ userDetails: userDetail.data });
      console.log("user id", userDetail.data);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
     }
      console.log(`😱 Axios request failed: ${e}`);
    }

    let Urlgroups = `${apiHost}/api/Auth/GroupsByUser/${userId}?${query}`;
    this.postGroups(Urlgroups);
    let Urlassets = `${apiHost}/api/Auth/AssetByUser/${userId}?${query}`;
    this.postAssets(Urlassets);
  }

//Sort functionality of Assets table starts here

handleSortString = (name) => {
  this.setState({
    sortString: name,
    sortDirection: 'asc'
  });
  this.sortStringName = name;
  this.sortDirection = 'asc';
  this.callback(name, this.sortDirection);
}
handleSortDirection = () => {
  if (this.state.sortDirection == 'asc') {
    this.setState({
      sortDirection: 'des'
    })
    this.sortDirection = 'des';
  } else {
    this.setState({
      sortDirection: 'asc'
    })
    this.sortDirection = "asc";
  }
  this.callback(this.sortStringName, this.sortDirection);
}

callback = (name, order) => {
  this.handleSort(name, order);
}
handleSort = (name, order) => {

  let userId = this.props.match.params.id;
  this.sortString = name;
  this.sortDirection = order;
  console.log("name", this.sortString, "order", this.sortDirection);
  let query = encodeQueryData(this.setAssetQueryObject());

  let urlAll = `${apiHost}/api/Auth/AssetByUser/${userId}?${query}`;
  this.postAssets(urlAll);

}
//Sort functionality of Assets table ends here
//Sort functionality of Group table starts here

handleSortStringGroup = (name) => {
  this.setState({
    sortStringGroup: name,
    sortDirectionGroup: 'asc'
  });
  this.sortStringNameGroup = name;
  this.sortDirectionGroup = 'asc';
  this.callbackGroup(name, this.sortDirectionGroup);
}
handleSortDirectionGroup = () => {
  if (this.state.sortDirectionGroup == 'asc') {
    this.setState({
      sortDirectionGroup: 'des'
    })
    this.sortDirectionGroup = 'des';
  } else {
    this.setState({
      sortDirectionGroup: 'asc'
    })
    this.sortDirectionGroup = "asc";
  }
  this.callbackGroup(this.sortStringNameGroup, this.sortDirectionGroup);
}

callbackGroup = (name, order) => {
  this.sortFunctionGroup(name, order);
}
sortFunctionGroup = (name, order) => {

  let userId = this.props.match.params.id;
  this.sortStringGroup = name;
  this.sortDirectionGroup = order;
  console.log("name", this.sortStringGroup, "order", this.sortDirectionGroup);
  let query = encodeQueryData(this.setGroupQueryObject());

  console.log("query Group noject", query)

  let urlAll = `${apiHost}/api/Auth/GroupsByUser/${userId}?${query}`;
  this.postGroups(urlAll);

}
//Sort functionality of user table ends here



  handleGroupsPagination = page => {
    let userId = this.props.match.params.id;
    this.groupsPageKey = page;
    let query = encodeQueryData(this.setGroupQueryObject());
    let urlAll = `${apiHost}/api/Auth/GroupsByUser/${userId}?${query}`;
    this.postGroups(urlAll);
  };

  handleGroupSearch = inputSearch => {
    //filtered by message on showing results
    if (inputSearch == "") {
      this.setState({ filterMessageG: false });
    } else {
      this.setState({ filterMessageG: true });
    }
    let userId = this.props.match.params.id;
    this.groupsSearchText = inputSearch;
    let query = encodeQueryData(this.setGroupQueryObject());
    let urlAll = `${apiHost}/api/Auth/GroupsByUser/${userId}?${query}`;
    this.postGroups(urlAll);
  };
  handleGroupShowEntries = inputShowEntries => {
    let userId = this.props.match.params.id;
    this.groupsPageSize = inputShowEntries;
    let query = encodeQueryData(this.setGroupQueryObject());
    let urlAll = `${apiHost}/api/Auth/GroupsByUser/${userId}?${query}`;
    this.postGroups(urlAll);
  };

  setGroupQueryObject = () => {
    let data = {};
    data.SearchString = this.groupsSearchText;
    data.PageSize = this.groupsPageSize;
    data.PageNumber = this.groupsPageKey;
    data.SortDirection = this.sortDirectionGroup;
    data.SortString = this.sortStringGroup;
    return data;
  };

  postGroups = async url => {
    try {
      const groupDetails = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );
      this.setState({
        groupDetails: groupDetails.data,
        groupPageCount: JSON.parse(groupDetails.headers.pagination).totalPages
      });
      this.handleShowGroupsResults(groupDetails);

      console.log("groupDetails ", groupDetails.data);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
     }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleShowGroupsResults = response => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntryG: JSON.parse(response.headers.pagination).totalItems
    });
    if (!this.state.totalFilterG) {
      this.setState({
        totalEntryFilterG: JSON.parse(response.headers.pagination).totalItems,
        totalFilterG: true
      });
    }
    this.setState({
      entryStartG:
        (parseInt(this.groupsPageKey) - 1) * parseInt(this.groupsPageSize) + 1
    });
    if (
      JSON.parse(response.headers.pagination).totalItems <
      parseInt(this.state.entryEndG)
    ) {
      this.setState({
        entryEndG: JSON.parse(response.headers.pagination).totalItems
      });
    } else {
      let value =
        parseInt(JSON.parse(response.headers.pagination).currentPage) *
        parseInt(this.groupsPageSize);
      this.setState({ entryEndG: value });
    }
    if (
      this.state.entryEndG >
      parseInt(JSON.parse(response.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEndG: JSON.parse(response.headers.pagination).totalItems
      });
    }
    if (this.state.groupDetails == "") {
      this.setState({ entryStartG: "0", entryEndG: "0", totalEntryG: "0" });
    }
  };
  handleAssetsPagination = page => {
    let userId = this.props.match.params.id;
    this.assetsPageKey = page;
    let query = encodeQueryData(this.setAssetQueryObject());
    let urlAll = `${apiHost}/api/Auth/AssetByUser/${userId}?${query}`;
    this.postAssets(urlAll);
  };

  handleAssetsSearch = inputSearch => {
        //filtered by message on showing results
        if (inputSearch == "") {
          this.setState({ filterMessageA: false });
        } else {
          this.setState({ filterMessageA: true });
        }
    let userId = this.props.match.params.id;
    this.assetsSearchText = inputSearch;
    let query = encodeQueryData(this.setAssetQueryObject());
    let urlAll = `${apiHost}/api/Auth/AssetByUser/${userId}?${query}`;
    this.postAssets(urlAll);
  };
  handleAssetsShowEntries = inputShowEntries => {
    let userId = this.props.match.params.id;
    this.assetsPageSize = inputShowEntries;
    let query = encodeQueryData(this.setAssetQueryObject());
    let urlAll = `${apiHost}/api/Auth/AssetByUser/${userId}?${query}`;
    this.postAssets(urlAll);
  };

  setAssetQueryObject = () => {
    let data = {};
    data.SearchString = this.assetsSearchText;
    data.PageSize = this.assetsPageSize;
    data.PageNumber = this.assetsPageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = this.sortString;
    return data;
  };

  postAssets = async url => {
    this.props.setLoadingPageAction(true);

    try {
      const assetDetails = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );
      this.setState({
        assetDetails: assetDetails.data,
        assetPageCount: JSON.parse(assetDetails.headers.pagination).totalPages
      });
      this.handleShowAssetsResults(assetDetails);
      console.log("assetDetails ", assetDetails.data);
      this.props.setLoadingPageAction(false);

    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
     }else{
      this.props.setErrorMessageAction(`${e}`)

    }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };
  handleShowAssetsResults = response => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntryA: JSON.parse(response.headers.pagination).totalItems
    });
    if (!this.state.totalFilterA) {
      this.setState({
        totalEntryFilterA: JSON.parse(response.headers.pagination).totalItems,
        totalFilterA: true
      });
    }
    this.setState({
      entryStartA:
        (parseInt(this.assetsPageKey) - 1) * parseInt(this.assetsPageSize) + 1
    });
    if (
      JSON.parse(response.headers.pagination).totalItems <
      parseInt(this.state.entryEndG)
    ) {
      this.setState({
        entryEndA: JSON.parse(response.headers.pagination).totalItems
      });
    } else {
      let value =
        parseInt(JSON.parse(response.headers.pagination).currentPage) *
        parseInt(this.assetsPageSize);
      this.setState({ entryEndA: value });
    }
    if (
      this.state.entryEndA >
      parseInt(JSON.parse(response.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEndA: JSON.parse(response.headers.pagination).totalItems
      });
    }
    if (this.state.assetDetails == "") {
      this.setState({ entryStartA: "0", entryEndA: "0", totalEntryA: "0" });
    }
  };

  handleSubmit() {
    this.props.history.push(`/editUser/${this.state.userDetails.id}`);
  }
  render() {
    const arr = [10, 25, 50, 100];

    return (
      <div>
        <React.Fragment>
         <Layout>

<Helmet>
<title>User Details </title>

</Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>User Details</h2>
              <h6>Platform Admin</h6>
              <hr></hr>

              <Tabs id="controlled-tab-example">
                <Tab eventKey="details" title="Details">
                  <Container>
                    <div className="userDetails">
                      <div className="individualDetail">
                        <p className="left"> Customer Name</p>
                        <p className="right">
                          {" "}
                          {this.state.userDetails.customerName}
                        </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> Email</p>
                        <p className="right"> {this.state.userDetails.email}</p>
                      </div>
                      <div className="individualDetail">
                        <p className="left">Name</p>
                        <p className="right">
                          {this.state.userDetails.userName}
                        </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left">Description</p>
                        <p className="right">
                          {this.state.userDetails.description}
                        </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> PasswordHash</p>
                        <p className="right"> </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> SecurityStamp</p>
                        <p className="right"> </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> UserType</p>
                        <p className="right">
                          {" "}
                          {this.state.userDetails.userType}
                        </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> TimeZoneID</p>
                        <p className="right">
                          {" "}
                          {this.state.userDetails.timeZoneId}
                        </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left">TimeFormat</p>
                        <p className="right"> </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> DateFormat</p>
                        <p className="right"> </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> SessionID</p>
                        <p className="right"> </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> ClientIPAddress</p>
                        <p className="right">
                          {" "}
                          {this.state.userDetails.clientIp}
                        </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> LastLogin</p>
                        <p className="right">
                          {" "}
                          {this.state.userDetails.lastLogin}
                        </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> Status</p>
                        <p className="right">
                          {" "}
                          {this.state.userDetails.status}
                        </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> Created</p>
                        <p className="right"> {utcToLocal(this.state.userDetails.dbCreated)} </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> Updated</p>
                        <p className="right">
                          {utcToLocal(this.state.userDetails.dbUpdated)}{" "}
                        </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> EmailConfirmed</p>
                        <p className="right"> </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> PhoneNumber</p>
                        <p className="right"> </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> PhoneNumberConfirmed</p>
                        <p className="right"> </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left">TwoFactorEnabled</p>
                        <p className="right"> </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> LockoutEndDateUtc</p>
                        <p className="right"> </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> LockoutEnabled</p>
                        <p className="right"> </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> AccessFailedCount</p>
                        <p className="right"> </p>
                      </div>
                      {/* <div className="individualDetail">
                        <p className="left"> CommunityID</p>
                        <p className="right"> </p>
                      </div>
                      <div className="individualDetail">
                        <p className="left"> ExternalID</p>
                        <p className="right"> </p>
                      </div> */}
                    </div>
                  </Container>
                </Tab>
                <Tab eventKey="groups" title="Groups">
                  <div className="inline">
                    {" "}
                    <ShowEntries
                      data={arr}
                      showEntriesCallback={this.handleGroupShowEntries}
                      />
                    <Search searchCallback={this.handleGroupSearch}></Search>
                  </div>
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>Name {this.state.sortStringGroup == 'name' ? <i onClick={this.handleSortDirectionGroup} className={`fa ${this.state.sortDirectionGroup == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortStringGroup("name") }} />}</th>
                        <th>Description</th>
                        <th>Status {this.state.sortStringGroup == 'status' ? <i onClick={this.handleSortDirectionGroup} className={`fa ${this.state.sortDirectionGroup == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortStringGroup("status") }} />}</th>
                        <th>Updated {this.state.sortStringGroup == 'updated' ? <i onClick={this.handleSortDirectionGroup} className={`fa ${this.state.sortDirectionGroup == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortStringGroup("updated") }} />}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.groupDetails.map((groups, index) => {
                        return (
                          <tr>
                            <td>{groups.name}</td>
                            <td>{groups.description}</td>
                            <td>{groups.status}</td>
                            <td>{groups.dbUpdated}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  <div className="paginationDetails">
                    <ShowingResults
                      currentEntryStart={this.state.entryStartG}
                      currentEntryEnd={this.state.entryEndG}
                      totalEntries={this.state.totalEntryG}
                      totalFilterEntries={this.state.totalEntryFilterG}
                      filterMessage={this.state.filterMessageG}
                      />
                    <Paginations
                      onPagination={this.handleGroupsPagination}
                      pageCount={this.state.groupPageCount}
                      pageRange={5}
                      ></Paginations>
                  </div>
                </Tab>
                <Tab eventKey="assets" title="Assets">
                  <div className="inline">
                    {" "}
                    <ShowEntries
                      data={arr}
                      showEntriesCallback={this.handleAssetsShowEntries}
                      />
                    <Search searchCallback={this.handleAssetsSearch}></Search>
                  </div>
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>Name {this.state.sortString == 'name' ? <i onClick={this.handleSortDirection} className={`fa ${this.state.sortDirection == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortString("name") }} />} </th>
                        <th>Tag1 {this.state.sortString == 'tag1' ? <i onClick={this.handleSortDirection} className={`fa ${this.state.sortDirection == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortString("tag1") }} />} </th>
                        <th>Tag2 {this.state.sortString == 'tag2' ? <i onClick={this.handleSortDirection} className={`fa ${this.state.sortDirection == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortString("tag2") }} />} </th>
                        <th>Description</th>
                        <th>Status {this.state.sortString == 'status' ? <i onClick={this.handleSortDirection} className={`fa ${this.state.sortDirection == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortString("status") }} />} </th>
                        <th>Updated {this.state.sortString == 'updated' ? <i onClick={this.handleSortDirection} className={`fa ${this.state.sortDirection == 'asc' ? "fa-sort-amount-asc" : "fa-sort-amount-desc"}`} /> : <i className="fa fa-exchange" onClick={() => { this.handleSortString("updated") }} />} </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.assetDetails.map((assets, index) => {
                        return (
                          <tr>
                            <td>{assets.name}</td>

                            <td>{assets.tag1}</td>
                            <td>{assets.tag2}</td>

                            <td>{assets.description}</td>
                            <td>{assets.status}</td>
                            <td>{assets.dbUpdated}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  <div className="paginationDetails">
                    <ShowingResults
                      currentEntryStart={this.state.entryStartA}
                      currentEntryEnd={this.state.entryEndA}
                      totalEntries={this.state.totalEntryA}
                      totalFilterEntries={this.state.totalEntryFilterA}
                      filterMessage={this.state.filterMessageA}
                      />
                    <Paginations
                      onPagination={this.handleAssetsPagination}
                      pageCount={this.state.assetPageCount}
                      pageRange={5}
                      ></Paginations>
                  </div>

                </Tab>
              </Tabs>
              <div className="footer-menu">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => {
                  //  this.props.history.push("/users");
                  this.props.history.goBack();
                  }}
                  >
                  Back to List
                </Button>
                &nbsp;
                <Button
                  size="sm"
                  variant="primary"
                  onClick={this.handleSubmit.bind(this)}
                  >
                  Edit
                </Button>
              </div>
            </div>
          </div>
                  </Layout>

        </React.Fragment>
      </div>
    );
  }
}


const mapStateToProps= (state)=>({

  loading:state.loading

})
const mapDispatchToProps= {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction:setErrorMessage


}

export default connect(mapStateToProps,mapDispatchToProps)(UserDetails);
